<template>
    <div class="edit-control">
        <div class="container edit-control-window justify-content-center">
            <div class="row justify-content-around">
                <div class="col-12 justify-content-center">
                    <div ref="editButtonsRef" class="edit-buttons">
                        <div
                            v-for="option in sharedState.editControlSource.data"
                            :class="{ 'option-selected': option.selected }"
                            v-bind:key="option.key"
                            @click="onClickOption(option)"
                        >
                            {{ option.item.buttonDesc }}
                        </div>
                        <!-- <b-form-select v-model="editControlSelected" :options="editControlOptions" :select-size="4"></b-form-select> -->
                    </div>
                </div>
            </div>
            <div class="row justify-content-around">
                <div class="col-8 d-flex justify-content-center">
                    <b-button class="m-1" @click="playEditControlOption">
                        <img
                            class="edit-contro-button-img"
                            src="../assets/pic/play_arrow_white_36dp.png"
                        />
                    </b-button>
                    <b-button class="m-1" @click="stopEditControlOption">
                        <img
                            class="edit-contro-button-img"
                            src="../assets/pic/stop_white_36dp.png"
                        />
                    </b-button>
                    <b-button
                        class="m-1 edit-contro-button-str"
                        @click="deleteEditControlOption"
                        >消</b-button
                    >
                    <b-button
                        class="m-1 edit-contro-button-str"
                        @click="toUpperEditControlOption"
                        >↑</b-button
                    >
                    <b-button
                        class="m-1 edit-contro-button-str"
                        @click="toLowerEditControlOption"
                        >↓</b-button
                    >
                </div>
                <div class="col-4 d-flex justify-content-end">
                    <b-button
                        class="m-1 edit-contro-button-str"
                        @click="toSelectedButtonPage"
                        >ページ作成</b-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AudioSourcePlayable from '@/mixins/AudioSourcePlayable'
import store from '@/store/store'

export default {
    name: 'EditControl',
    mixins: [AudioSourcePlayable],
    data: function () {
        return {
            sharedState: store.editControl.state,
        }
    },
    methods: {
        onClickOption: function (selectedOption) {
            store.editControl.setEditControlSelected(selectedOption)
        },
        playEditControlOption: function () {
            const selectedItem = store.editControl.getEditControlSelected()
            if (selectedItem == null) {
                return
            }
            this.play(selectedItem)
        },
        stopEditControlOption: function () {
            this.stopSound()
        },
        deleteEditControlOption: function () {
            const selectedItem = store.editControl.getEditControlSelected()
            if (selectedItem == null) {
                return
            }
            store.editControl.deleteEditControlItem(selectedItem)
            store.editControl.resetEditControlSelected()
        },
        toUpperEditControlOption: function () {
            const selectedItem = store.editControl.getEditControlSelected()
            if (selectedItem == null) {
                return
            }
            store.editControl.toUpperEditControlOption(selectedItem)
        },
        toLowerEditControlOption: function () {
            const selectedItem = store.editControl.getEditControlSelected()
            if (selectedItem == null) {
                return
            }
            store.editControl.toLowerEditControlOption(selectedItem)
        },
        toSelectedButtonPage: function () {
            this.$emit('to-button-page')
        },
        scrollToBottom: function () {
            this.$nextTick(function () {
                const editButtonsRef = this.$refs.editButtonsRef
                editButtonsRef.scrollTop = editButtonsRef.scrollHeight
            })
        },
    },
    watch: {
        'sharedState.editControlSource.data': function () {
            this.scrollToBottom()
        },
    },
}
</script>

<style scoped>
.edit-control {
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateY(0%) translateX(-50%);
    width: 100%;
}

.edit-control-window {
    max-width: 600px;
    background-color: rgba(0, 0, 0, 0.8);
    border: solid;
    border-color: rgba(0, 0, 0, 0.2);
    border-radius: 10px 10px;
}
.edit-buttons {
    overflow-y: auto;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 5px;
    margin: 5px;
    height: 100px;
}
.option-selected {
    background-color: rgba(0, 0, 0, 0.2);
}
.option-unselected {
    background-color: rgba(0, 0, 0, 1);
}
.edit-contro-button-img {
    width: 15px;
    height: 15px;
}
.edit-contro-button-str {
    font-size: small;
}
</style>
